import { Injectable, OnDestroy } from "@angular/core";

/**
 * Stops mouse-wheel from incrementing/decrementing native number inputs.
 * Browsers adjust `input[type=number]` on wheel by default, which is easy
 * to trigger accidentally while scrolling long amount forms.
 */
@Injectable({ providedIn: "root" })
export class PreventNumberScrollService implements OnDestroy {
  private readonly onWheel = (event: WheelEvent): void => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.type !== "number") return;
    event.preventDefault();
  };

  constructor() {
    document.addEventListener("wheel", this.onWheel, {
      passive: false,
      capture: true,
    });
  }

  ngOnDestroy(): void {
    document.removeEventListener("wheel", this.onWheel, { capture: true });
  }
}
